/* PC theme kit — JS dùng chung cho các section pc-* */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: cur });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Chấm màu trên thẻ sản phẩm: rê/bấm → đổi ảnh + nhớ màu đang chọn ---------- */
  function swap(swatch) {
    var card = swatch.closest('.pc-card');
    if (!card) return;
    var url = swatch.getAttribute('data-pc-swatch-img');
    var img = card.querySelector('.pc-card__img');
    if (url && img) {
      img.removeAttribute('srcset');
      img.src = url;
    }
    card.querySelectorAll('.pc-swatch').forEach(function (s) { s.removeAttribute('aria-current'); });
    swatch.setAttribute('aria-current', 'true');
    card.dataset.pcColor = swatch.getAttribute('title') || '';
  }
  document.addEventListener('mouseover', function (e) {
    var s = e.target.closest && e.target.closest('.pc-swatch[data-pc-swatch-img]');
    if (s) swap(s);
  });
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('.pc-card .pc-swatch');
    if (s) { e.preventDefault(); swap(s); }
  });

  /* ---------- Quick add: chọn màu + size rồi thêm giỏ ngay trên trang collection ---------- */
  var sheet, body, state;

  function buildSheet() {
    sheet = document.createElement('dialog');
    sheet.className = 'pc-quick';
    sheet.setAttribute('aria-label', 'Quick add');
    sheet.innerHTML =
      '<div class="pc-quick__inner">' +
      '<button type="button" class="pc-quick__close" data-pc-quick-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<div class="pc-quick__body" data-pc-quick-body></div></div>';
    document.body.appendChild(sheet);
    body = sheet.querySelector('[data-pc-quick-body]');
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-pc-quick-close]')) { sheet.close(); return; }
      var c = e.target.closest('[data-pc-q-color]');
      if (c) { state.color = c.dataset.pcQColor; state.size = state.size && variantFor(state.color, state.size) ? state.size : null; render(); return; }
      var z = e.target.closest('[data-pc-q-size]');
      if (z && !z.disabled) { state.size = z.dataset.pcQSize; render(); return; }
      if (e.target.closest('[data-pc-q-add]')) add();
    });
  }

  function optName(o) { return typeof o === 'string' ? o : o && o.name; }
  function variantFor(color, size) {
    return state.p.variants.find(function (v) {
      return (state.ci < 0 || v.options[state.ci] === color) && (state.si < 0 || v.options[state.si] === size);
    });
  }
  function uniq(idx) {
    var out = [];
    state.p.variants.forEach(function (v) { if (idx >= 0 && out.indexOf(v.options[idx]) < 0) out.push(v.options[idx]); });
    return out;
  }

  function render() {
    var p = state.p;
    var colorVariant = p.variants.find(function (v) { return state.ci < 0 || v.options[state.ci] === state.color; }) || p.variants[0];
    var chosen = state.si < 0 ? colorVariant : (state.size ? variantFor(state.color, state.size) : null);
    var shown = chosen || colorVariant;
    var img = (shown.featured_image && shown.featured_image.src) || p.featured_image;
    var html = '';
    html += '<div class="pc-quick__head">';
    if (img) html += '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" width="96" height="120">';
    html += '<div><p class="pc-quick__title">' + esc(p.title) + '</p><p class="pc-quick__price">' + money(shown.price);
    if (shown.compare_at_price > shown.price) html += ' <s>' + money(shown.compare_at_price) + '</s>';
    html += '</p></div></div>';

    if (state.ci >= 0) {
      html += '<p class="pc-quick__label">Color: <strong>' + esc(state.color) + '</strong></p><div class="pc-quick__colors">';
      uniq(state.ci).forEach(function (c) {
        var hex = state.colors[c] || '#ccc';
        html += '<button type="button" class="pc-quick__color" data-pc-q-color="' + esc(c) + '" title="' + esc(c) + '" aria-label="' + esc(c) + '"' +
          (c === state.color ? ' aria-pressed="true"' : ' aria-pressed="false"') + ' style="--pc-swatch:' + esc(hex) + '"></button>';
      });
      html += '</div>';
    }
    if (state.si >= 0) {
      html += '<p class="pc-quick__label">Size: <strong>' + (state.size ? esc(state.size) : '—') + '</strong>' +
        '<a class="pc-quick__guide" href="' + esc(p.url) + '#pc-size-guide">Size guide</a></p><div class="pc-quick__sizes">';
      uniq(state.si).forEach(function (s) {
        var v = variantFor(state.color, s);
        var ok = v && v.available;
        html += '<button type="button" class="pc-quick__size" data-pc-q-size="' + esc(s) + '"' + (ok ? '' : ' disabled') +
          (s === state.size ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' + esc(s) + '</button>';
      });
      html += '</div>';
    }
    var canAdd = chosen && chosen.available;
    html += '<button type="button" class="button pc-quick__add" data-pc-q-add' + (canAdd ? '' : ' disabled') + '>' +
      (state.busy ? 'Adding…' : canAdd ? 'Add to cart · ' + money(chosen.price) : state.si >= 0 && !state.size ? 'Choose a size' : 'Sold out') + '</button>';
    html += '<p class="pc-quick__error" role="alert">' + esc(state.error || '') + '</p>';
    html += '<a class="pc-quick__details" href="' + esc(p.url) + '">View full details →</a>';
    body.innerHTML = html;
  }

  function add() {
    var v = state.si < 0 ? variantFor(state.color) : variantFor(state.color, state.size);
    if (!v || !v.available || state.busy) return;
    state.busy = true;
    state.error = '';
    render();
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var payload = { id: v.id, quantity: 1 };
    if (cart && cart.getSectionsToRender) {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    fetch(((window.routes && window.routes.cart_add_url) || ROOT + 'cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        state.busy = false;
        if (!res.ok || res.j.status) {
          state.error = res.j.description || res.j.message || 'Could not add to cart.';
          render();
          return;
        }
        sheet.close();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pc-quick-add', productVariantId: v.id, cartData: res.j });
        }
        if (cart && cart.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(res.j);
        } else {
          window.location.href = ROOT + 'cart';
        }
      })
      .catch(function () {
        state.busy = false;
        state.error = 'Could not add to cart. Please try again.';
        render();
      });
  }

  function openQuick(btn) {
    if (!sheet) buildSheet();
    var card = btn.closest('.pc-card');
    var colors = {};
    try { colors = JSON.parse(btn.dataset.pcColors || '{}'); } catch (e) {}
    body.innerHTML = '<p class="pc-quick__loading">Loading…</p>';
    if (!sheet.open) sheet.showModal();
    fetch(ROOT + 'products/' + btn.dataset.pcQuick + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var names = (p.options || []).map(optName);
        var ci = names.findIndex(function (n) { return /^colou?r$/i.test(n || ''); });
        var si = names.findIndex(function (n) { return /size/i.test(n || ''); });
        state = { p: p, ci: ci, si: si, colors: colors, size: null, busy: false, error: '' };
        var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
        state.color = (card && card.dataset.pcColor) || (ci >= 0 ? first.options[ci] : null);
        if (ci >= 0 && !p.variants.some(function (v) { return v.options[ci] === state.color; })) state.color = first.options[ci];
        render();
      })
      .catch(function () { body.innerHTML = '<p class="pc-quick__loading">Could not load this product.</p>'; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pc-quick]');
    if (btn) { e.preventDefault(); openQuick(btn); }
  });
})();

/* pc-cart-upsell: mũi tên cuộn dải "Pairs great with" (drawer + trang /cart).
   Dùng event delegation vì drawer được render lại sau mỗi lần cập nhật giỏ. */
(function () {
  function sync(box) {
    var t = box.querySelector('.pc-upsell__track');
    if (!t) return;
    var max = t.scrollWidth - t.clientWidth - 2;
    var prev = box.querySelector('[data-pc-upsell="-1"]');
    var next = box.querySelector('[data-pc-upsell="1"]');
    if (prev) prev.disabled = t.scrollLeft <= 2;
    if (next) next.disabled = t.scrollLeft >= max;
    box.classList.toggle('pc-upsell--static', max <= 0);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pc-upsell]');
    if (!btn) return;
    var box = btn.closest('.pc-upsell');
    var t = box && box.querySelector('.pc-upsell__track');
    if (!t) return;
    var item = t.querySelector('.pc-upsell__item');
    var step = item ? item.getBoundingClientRect().width + 12 : t.clientWidth * 0.8;
    t.scrollBy({ left: step * parseInt(btn.getAttribute('data-pc-upsell'), 10), behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('pc-upsell__track')) sync(t.closest('.pc-upsell'));
  }, true);
  function syncAll() { document.querySelectorAll('.pc-upsell').forEach(sync); }
  document.addEventListener('DOMContentLoaded', syncAll);
  window.addEventListener('resize', syncAll);
  // drawer mở / render lại → cập nhật trạng thái mũi tên
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; syncAll(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
